import {
  getTrackerId,
  POSTHOG_CAPTURE_ATTRIBUTES,
  TRACKER_IDS,
} from '../config/tracker';

const SUBSCRIPTION_STEPS = {
  SELECTION: 'selection',
  PAYMENT: 'payment',
  DIRECT_PAYMENT: 'direct-payment',
  CONFIRMATION: 'confirmation',
};

const SUBSCRIPTION_PAYMENT_TYPES = {
  ONE_TIME: 'one-time',
  SUBSCRIPTION: 'subscription',
};

const getSubscriptionStepTrackerProps = (step, type) => {
  if (!step || !type || !TRACKER_IDS.subscription?.[step]?.[type]) {
    return {};
  }

  return {
    [POSTHOG_CAPTURE_ATTRIBUTES.TRACKER_ID]: getTrackerId(TRACKER_IDS.subscription[step][type]),
  };
};

const SUBSCRIPTION_ORDER_ITEMS_STORAGE_KEY = 'subscriptionOrderItems';

const setSubscriptionOrderItemsInStorage = (orderItems) => {
  window.localStorage.setItem(SUBSCRIPTION_ORDER_ITEMS_STORAGE_KEY, JSON.stringify(orderItems));
};

const getSubscriptionOrderItemsFromStorage = () => {
  const orderItems = window.localStorage.getItem(SUBSCRIPTION_ORDER_ITEMS_STORAGE_KEY);

  try {
    return orderItems ? JSON.parse(orderItems) : null;
  } catch (error) {
    console.error('Error parsing SUBSCRIPTION_ORDER_ITEMS_STORAGE_KEY from storage:', error);
    return null;
  }
};

const resetSubscriptionOrderItemsInStorage = () => {
  window.localStorage.removeItem(SUBSCRIPTION_ORDER_ITEMS_STORAGE_KEY);
};

const getOrderSubtotal = (orderItems = {}, productPrices = {}, membershipItems = []) => (
  Object.keys(orderItems).reduce((acc, itemId) => {
    const count = orderItems[itemId] || 0;
    const value = (productPrices[itemId] ?? 0) * count;

    if (membershipItems.includes(itemId)) {
      return acc + value;
    }

    return acc;
  }, 0)
);

const getSubscriptionConfigOptionSelectedData = (subscriptionConfig = {}, optionSelected = '') => (
  subscriptionConfig?.steps?.[SUBSCRIPTION_STEPS.SELECTION]?.sections
    ?.find(section => section.id === 'options')?.items
    ?.find(item => item.uid === optionSelected)
);

const getIntervalTag = (interval = '') => (
  interval && <sup>{`/${interval}`}</sup>
);

const getSubscriptionPlanValue = (value) => (value ?? 0) / 100;

const getSubscriptionPlanValues = (plan = {}) => {
  const value = plan?.discountedPriceCents || plan?.fullPriceCents;
  const prevValue = plan?.discountedPriceCents ? plan?.fullPriceCents : 0;

  return {
    value: getSubscriptionPlanValue(value ?? 0),
    prevValue: getSubscriptionPlanValue(prevValue ?? 0),
  };
};

const getSubscriptionPlanInterval = (interval = '') => {
  switch (interval) {
    case 'year':
      return 'yr';
    case 'month':
      return 'mo';
    default:
      return '';
  }
};

export {
  SUBSCRIPTION_STEPS,
  SUBSCRIPTION_PAYMENT_TYPES,
  getSubscriptionStepTrackerProps,
  getOrderSubtotal,
  setSubscriptionOrderItemsInStorage,
  getSubscriptionOrderItemsFromStorage,
  resetSubscriptionOrderItemsInStorage,
  getSubscriptionConfigOptionSelectedData,
  getIntervalTag,
  getSubscriptionPlanValue,
  getSubscriptionPlanValues,
  getSubscriptionPlanInterval,
};
